// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"_labLayout_mainContainer__xPu81"};